import { Shift } from "@shiftly/shared/src/schema";
import { DateTime } from "luxon";

export const DAYS_OF_WEEK = [
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
  'Sunday'
];

export const getCompletionStatus = (shift: Shift) => {
  if (shift.submitted) {
    return "Completed";
  }
  
  const now = DateTime.now().setZone('Europe/London');
  const shiftStartGMT = shift.start_date_time.setZone('Europe/London');
  const shiftStartCorrected = now.isInDST ? shiftStartGMT.minus({ minutes: 60 }) : shiftStartGMT;

  if (!shift.clocked_in) {
    const earliestClockIn = shiftStartCorrected.minus({ minutes: 30 });
    
    if (now < earliestClockIn) {
      return `Clock in available ${earliestClockIn.toRelative({ base: now })}`;
    }
    
    return "Clock in required";
  }
  
  const shiftEndGMT = shift.end_date_time.setZone('Europe/London');
  const shiftEndCorrected = now.isInDST ? shiftEndGMT.minus({ minutes: 60 }) : shiftEndGMT;

  if (now < shiftStartCorrected) {
    return `Starts ${shiftStartCorrected.toRelative({ base: now })}`;
  }

  if (now < shiftEndCorrected) {
    return `Completable ${shiftEndCorrected.toRelative({ base: now })}`;
  }
  
  return "Ready to complete";
};

export const TERMS_ACCEPTED_VERSION = "1.4.0";
export const PRIVACY_POLICY_ACCEPTED_VERSION = "1.4.0";
